export default [
  {
    path: '/userdietorder',
    name: 'userdietorder',
    component: () => import('@/views/menu/order/userdietorder.vue'),
    meta: {
      pageTitle: 'مدیریت سفارش ها',
      action: 'show',
      resource: 'OrderView',
    },
  },
  {
    path: '/activitypackageorder',
    name: 'activitypackageorder',
    component: () => import('@/views/menu/order/activitypackageorder.vue'),
    meta: {
      pageTitle: 'مدیریت سفارش ها',
      action: 'show',
      resource: 'OrderView',
    },
  },
  {
    path: '/discount',
    name: 'discount',
    component: () => import('@/views/menu/order/discount.vue'),
    meta: {
      pageTitle: 'مدیریت تخفیف ها',
      action: 'show',
      resource: 'CouponManager',
    },
  },
  {
    path: '/discount/details',
    name: 'adddiscount',
    component: () => import('@/views/menu/order/discountdetails.vue'),
    meta: {
      pageTitle: 'ایجاد تخفیف',
      action: 'show',
      resource: 'CouponManager',
    },
  },
  {
    path: '/discount/details/:id',
    name: 'updatediscount',
    component: () => import('@/views/menu/order/discountdetails.vue'),
    meta: {
      pageTitle: 'ویرایش تخفیف',
      action: 'show',
      resource: 'CouponManager',
    },
  },
]
